import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import MOMABffService from '@/services/moma-bff.service';
import { HomeSettingsBannerDTO } from '@/data/dto/homeSettings.dto';

const service = new MOMABffService();

@Module
export default class HomeSettingsModule extends VuexModule {
  homeSettings: HomeSettingsBannerDTO | null = null;

  loading = {
    fetch: false,
    save: false,
  };

  @Action
  async getHomeSettings(): Promise<HomeSettingsBannerDTO> {
    try {
      this.context.commit('setFetchLoading', true);

      const response = await service.getHomeSettings();

      this.context.commit('setHomeSettings', response);

      return response;
    } catch (error: any) {
      this.context.commit(
        'showAlert',
        {
          message: 'Erro ao carregar configurações',
          type: 'danger',
        },
        { root: true }
      );

      throw error;
    } finally {
      this.context.commit('setFetchLoading', false);
    }
  }

  @Action
  async saveHomeSettings(payload: HomeSettingsBannerDTO): Promise<void> {
    try {
      this.context.commit('setSaveLoading', true);

      await service.saveHomeSettings(payload);

      this.context.commit('setHomeSettings', payload);

      this.context.commit(
        'showAlert',
        {
          message: 'Configurações salvas com sucesso!',
          type: 'success',
        },
        { root: true }
      );
    } catch (error: any) {
      const errorMessage = error?.message || 'Erro ao salvar configurações';
      this.context.commit(
        'showAlert',
        {
          message: errorMessage,
          type: 'danger',
        },
        { root: true }
      );

      throw error;
    } finally {
      this.context.commit('setSaveLoading', false);
    }
  }

  @Mutation
  setHomeSettings(payload: HomeSettingsBannerDTO): void {
    this.homeSettings = payload;
  }

  @Mutation
  setFetchLoading(value: boolean): void {
    this.loading.fetch = value;
  }

  @Mutation
  setSaveLoading(value: boolean): void {
    this.loading.save = value;
  }
}
